



























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import * as routes from "@/employee/route-names";
import { formatCurrency } from "@/shared/currency";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";

@Component
export default class HealthcareExpenseNavigation extends Vue {
  deductibleTrackerStore = useDeductibleTrackerStore();
  custodianSettingsStore = useCustodianSettingsStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();

  routes = routes;
  formatCurrency = formatCurrency;
  activeTab = null;

  mounted (): void {
    this.expenseBalanceSummaryStore.loadState();
    this.deductibleTrackerStore.loadTalonEnabledForUser();
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName,
    });
  }

  get reimbursedSubtitle () {
    return "YTD";
  }
}
